import {DeltaStatic} from "quill";

export function getFirstH1FromDelta(delta: DeltaStatic): string {
  const ops = delta?.ops || [];
  let buffer = '';

  for (let i = 0; i < ops.length; i++) {
    const op = ops[i];

    if (typeof op.insert === 'string') {
      buffer += op.insert;

      if (op.insert.includes('\n') && op.attributes?.header === 1) {
        const lines = buffer.split('\n');
        return lines[0].trim();
      }
    }

    if (
      typeof op.insert === 'string' &&
      op.insert === '\n' &&
      op.attributes?.header === 1
    ) {
      return buffer.trim();
    }
  }

  return "";
}

export function getAllImagesFromDelta(delta: DeltaStatic): string[] {
  const ops = delta?.ops || [];
  const images: string[] = [];

  for (const op of ops) {
    if (op.insert && typeof op.insert === 'object' && op.insert.image) {

      try {
        const parsedImageBlock = JSON.parse(op.insert.image)
        if (typeof parsedImageBlock === 'object') {
          images.push(parsedImageBlock.source);
        } else {
          images.push(op.insert.image);
        }
      } catch (e) {
        console.error('Parsing image error, ', op.insert.image);
      }
    }
  }

  return images;
}

export function getPlainTextPreview(delta: DeltaStatic, maxLength = 200): string {
  const ops = delta?.ops || [];
  let plainText = '';

  for (const op of ops) {
    if (typeof op.insert === 'string') {
      plainText += op.insert;
      if (plainText.length >= maxLength) {
        break;
      }
    }
  }

  return plainText.replace(/\s+/g, ' ').trim().slice(0, maxLength);
}

export const getFormattedDate = (publishingTime: string) => {

  const date = new Date(publishingTime);

// Получаем компоненты с учётом UTC
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();

  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

// Формируем итоговую строку
  const formatted = `${day}.${month}.${year} ${hours}:${minutes}`;

  return formatted
}
